import React from 'react'
import win from 'global/window'
import styles from './carousel.styles.module.scss'

function next(ev) {
  ev.preventDefault()
  const container = ev.target.closest('.' + styles.CarouselContainer)?.querySelector('.'+styles.CarouselContent)
  container.scrollLeft = Math.min(
    container.scrollLeft + container.offsetWidth,
    container.scrollWidth
  )
}

function prev(ev) {
  ev.preventDefault()
  const container = ev.target.closest('.' + styles.CarouselContainer)?.querySelector('.'+styles.CarouselContent)
  container.scrollLeft = Math.max(container.scrollLeft - container.offsetWidth, 0)
}

const CarouselNav = () => {
  return (
    <div className={styles.CarouselNavigation}>
        <button className={styles.prev} onClick={prev}>
          <i className="fas fa-chevron-left"></i>
          <span className="Text -mod-accessibility-text">Previous</span>
        </button>
        <button className={styles.next} onClick={next}>
          <span className="Text -mod-accessibility-text">Next</span>
          <i className="fas fa-chevron-right"></i>
        </button>
    </div>
  )
}

function handleScrollWith(setIndex, count) {
  return function(ev) {
    const target = ev.target
    const container = target.closest('.' + styles.CarouselContainer)
    setIndex(Math.floor(container.scrollWidth / target.scrollLeft))
  }
}

const Carousel = (props) => {
  const [currIdx, setCurrentIdx] = React.useState(props?.initIdx ?? 1)
  const container = React.useRef()
  return (
    <div ref={container} className={`${styles.CarouselContainer} `}>
      <CarouselNav {...props} currentIndex={currIdx} />
      <div className={styles.CarouselContent}>{props?.children}</div>
    </div>
  )
}

export default Carousel
